import React from 'react';
import { Box } from '@mui/material';

const PageWidthLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Box
      sx={{
        margin: '0 auto',
      }}
    >
      {children}
    </Box>
  );
};

export default PageWidthLayout;
